import { PureComponent } from 'react'
import cx from 'classnames'
import { MCEEditor, withS3ServiceRequestConvertor } from '@vzmi/shp_shared_compo'
import { removeZeroWidthStyleFromHTML } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'
import { withFormError } from '../../../Common/Form'
import { REGEX_REPLACE_INVALID_YOUTUBE_IFRAME, REGEX_REPLACE_LINK, INVALID_STYLES_IMG } from '../../../Common/MCEEditor/shared'
import { withHTMLCheck } from './Shared/util'
import WithS3Service from '../../../../containers/Common/WithS3Service'
import styles from './MCEEditorField.css'

// custom alignment button list
const loadAlignmentButton = (editor) => {
  editor.addButton('alignment', {
    type: 'listbox',
    icon: 'alignleft',
    text: false,
    onselect: function (e) {
      window.tinymce.execCommand(this.value())
    },
    values: [
      { icon: 'alignleft', value: 'JustifyLeft' },
      { icon: 'alignright', value: 'JustifyRight' },
      { icon: 'aligncenter', value: 'JustifyCenter' },
      { icon: 'alignjustify', value: 'JustifyFull' }
    ],
    onPostRender: function () {
      // Select the firts item by default
      this.value('JustifyLeft')
    }
  })
}

// remove invalid content from input
const removeInvalidContent = (content) => {
  let localContent = content || ''
  localContent = localContent.replace(REGEX_REPLACE_INVALID_YOUTUBE_IFRAME, '')
  return localContent
}

// remove link content from input
const removeLinkFromContent = (content) => {
  let localContent = content || ''
  localContent = localContent.replace(REGEX_REPLACE_LINK, '')
  return localContent
}

/** tinymce editor configuration */
const DEFAULT_FONT_SIZE = '14px'
const editorConfig = {
  menubar: false,
  statusbar: false,
  min_height: 500,
  setup: (editor) => {
    loadAlignmentButton(editor)
  },
  plugins: [
    'lists textcolor colorpicker table paste link code',
    'youtubeembedder imageuploader imagelist'
  ],
  toolbar: [
    'fontsizeselect bold underline | outdent indent | alignment forecolor backcolor | table imageuploader youtubeembedder link code | imagelist'
  ],
  link_title: false,
  default_link_target: '_blank',
  fontsize_formats: '12px 14px 16px 18px 24px 30px 36px',
  table_advtab: false,
  paste_data_images: false,
  automatic_uploads: false,
  visual_table_class: ' ', // leaving space to remove default table class
  invalid_styles: {
    img: INVALID_STYLES_IMG
  },
  content_style: `
    #tinymce {font-size: ${DEFAULT_FONT_SIZE};}
    #tinymce p {margin: 0px;}
    img {max-width: 100%;}`,
  paste_preprocess: (plugin, args) => {
    // remove invalid content on paste
    args.content = removeInvalidContent(args.content)
    args.content = removeLinkFromContent(args.content)
  },
  // 不屬於tinyMCE官方的editor選項都集中於customOptions, 避免跟官方選項混淆
  customOptions: {
    beforeSetContentAdvancedCheck: withHTMLCheck
  }
}

const url = `${CDN}/supplier`
const imageListConfig = {
  text: '插入圖檔-四機相關費用',
  modalTitle: '進倉大家電收費＆跨區費用文案圖檔',
  list: [
    { url: `${url}/construction-cost_separate-air-conditionerV4.jpg`, title: '進倉施工費用_分離式冷氣' },
    { url: `${url}/construction-cost_refrigerator.jpg`, title: '進倉施工費用_冰箱' },
    { url: `${url}/construction-cost_washing-machine.jpg`, title: '進倉施工費用_洗衣機' },
    { url: `${url}/construction-cost_american-gas-clothes-dryer.jpg`, title: '進倉施工費用_美式(瓦斯)乾衣機' },
    { url: `${url}/construction-cost_clothes-dryer.jpg`, title: '進倉施工費用_乾衣機' },
    { url: `${url}/construction-cost_window-type-air-conditionerV2.jpg`, title: '進倉施工費用_窗型冷氣' },
    { url: `${url}/construction-cost_televisionV2.jpg`, title: '進倉施工費用_電視' },
    { url: `${url}/cost_cross-regionV2.jpg`, title: '進倉跨區費用(所有四機賣場都要放)' }
  ]
}

const MCEEditorWithS3 = WithS3Service(withS3ServiceRequestConvertor(MCEEditor))

/**
 * WYSIWYG editor field
 */
class MCEEditorField extends PureComponent {
  render () {
    const {
      input,
      isImageListBtnVisible,
      ...restProps
    } = this.props
    const content = input.value || ''

    return (
      <MCEEditorWithS3
        {...restProps}
        name={input.name}
        className={cx(
          // className 沒有變更 mce editor 不會重新 render component
          { [styles.showImageListBtn]: isImageListBtnVisible },
          { [styles.hideImageListBtn]: !isImageListBtnVisible }
        )}
        init={editorConfig}
        imageListConfig={imageListConfig}
        content={removeZeroWidthStyleFromHTML(content)}
        onBlur={(event, value) => input.onBlur()}
        onEditorChange={input.onChange}
      />
    )
  }
}

const MCEEditorFieldContainer = withFormError(MCEEditorField)

export default MCEEditorFieldContainer
